module.exports = __webpack_public_path__ + "assets/img/brand-must-be-protected_mobile.3311cf0c.svg";